import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-lg-column w-100" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FormField, {
        required: true,
        name: "first_name",
        containerClass: "col-lg-6 col-sm-12 col-xs-12",
        label: "First Name",
        placeholder: "First Name",
        type: "text"
      }),
      _createVNode(_component_FormField, {
        required: true,
        name: "last_name",
        containerClass: "col-lg-6 col-sm-12 col-xs-12",
        label: "Surname",
        placeholder: "Surname",
        type: "text"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_FormField, {
        required: true,
        name: "date_of_birth",
        containerClass: "col-lg-6 col-sm-12 col-xs-12",
        label: "Date of Birth",
        placeholder: "Pick a date",
        dateFormat: _ctx.dateFormat,
        disabledDates: _ctx.disableFutureDates,
        type: "datepicker"
      }, null, 8, ["dateFormat", "disabledDates"]),
      _createVNode(_component_FormField, {
        required: true,
        disabled: true,
        name: "email",
        containerClass: "col-lg-6 col-sm-12 col-xs-12",
        label: "Email",
        placeholder: "Email",
        type: "email",
        onInput: _ctx.handleEmailInput
      }, null, 8, ["onInput"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_FormField, {
        required: true,
        name: "mobile_number",
        containerClass: "col-lg-6 col-sm-12 col-xs-12",
        label: "Mobile Number",
        placeholder: "Mobile Number",
        type: "text",
        mask: _ctx.maskingMobile
      }, null, 8, ["mask"])
    ])
  ]))
}